import styled from 'styled-components';

import { Spacer, spaceMixin, token } from '@zillow/constellation';

export const StyledInlineSpacer = styled(Spacer)`
    display: inline-block;
`;

export const StyledBorderTopSpacer = styled(Spacer)`
    border-top: 1px solid ${token('colors.gray300')};
    padding-top: ${spaceMixin('xs')};
    margin-top: ${spaceMixin('md')};
`;
